import { render } from "./Coin.vue?vue&type=template&id=4f524a21"
import script from "./Coin.vue?vue&type=script&lang=js"
export * from "./Coin.vue?vue&type=script&lang=js"

import "./Coin.vue?vue&type=style&index=0&id=4f524a21&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__